import { NgModule } from '@angular/core';
import { SharedModule } from '../../shared/modules/shared.module';
import { CommonModule } from '@angular/common';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { RptSaldoComponent } from './rpt-saldo/rpt-saldo.component';
import { RptActivacionComponent } from './rpt-activacion/rpt-activacion.component';

@NgModule({
    imports: [
        FormsModule,
        CommonModule,
        SharedModule,
        ReactiveFormsModule
    ],
    exports: [],
    declarations: [
        RptSaldoComponent,
        RptActivacionComponent
    ],
    providers: [],
})
export class ReportModule { }
